import { FaDiscord } from "react-icons/fa";
import { handleOAuthLogin } from "../../lib/Utils/Utils";
import { useTranslation } from "react-i18next";
import { Button } from "../ui";

export function LoginButton({ fullWidth = false }) {
  const { t } = useTranslation();

  return (
    <Button
      onClick={() => handleOAuthLogin()}
      fullWidth={fullWidth}
      iconStart={<FaDiscord className="text-xl" aria-hidden="true" />}
      className="fade-in"
      style={{
        backgroundImage:
          "linear-gradient(to right, var(--color-discord), var(--color-discord-dark))",
      }}
    >
      {t("LoginButton.login")}
    </Button>
  );
}
